import React, { useState, useEffect } from "react";
import {
  Card,
  Form,
  Container,
  Row,
  Col,
} from "react-bootstrap";
import {
  getInquiryList,
  updateInquiries,
} from "../../actions/inquiryAction";
import { IoIosArrowUp } from "react-icons/io";
import resetBtn from "../../assets/images/reset-arrow.svg";
import downloadBtn from "../../assets/images/filter-download-btn.svg";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";
import { toast } from "react-toastify";
import DataTable, { createTheme } from "react-data-table-component";
import InitializeLocalStorage from "../../components/PaginationHandle";
import InquiryModal from "./inquiryModal";
import moment from "moment-timezone";


createTheme(
  "solarized",
  {
    text: {
      primary: "#000",
      secondary: "#000",
    },
    background: {
      default: "#fff",
    },
    context: {
      background: "#cb4b16",
      text: "#FFFFFF",
    },
    divider: {
      default: "#DFE0EB",
    },
    action: {
      button: "rgba(0,0,0,.54)",
      hover: "rgba(0,0,0,.08)",
      disabled: "rgba(0,0,0,.12)",
    },
  },
  "dark"
);

const Inquiry = () => {
  const [inquiries, setInquiries] = useState([]);
  const [loader, setLoader] = useState(false);
  const { admin } = useSelector((state) => state.admin);
  const currentUserRole = admin.role;
  const [filterText, setFilterText] = useState("");
  const [selectedOption, setSelectedOption] = useState();
  const [filteredItems, setFilteredItems] = useState([]);
  const [showRolesModal, setShowRolesModal] = useState(false);
  const [inquiryData, setInquiriesData] = useState();
  const [currentElement, setCurrentElement] =  useState();
  const [isFilterOpen, setIsFilterOpen] = useState(true);
  
  
  const location = useLocation();
  const { pathname } = location;

  InitializeLocalStorage(pathname, localStorage.getItem("currentURL"));

  const handleCloseModal = () => setShowRolesModal(false);

  const updateStatus = (event) => {
    const rowElement = event.target.closest('[role="row"]');
    if (rowElement) {
      const cellElement = rowElement.querySelector('[data-column-id="5"]');
      setCurrentElement(cellElement);
    }
  };
  
  const getInquiries = async (event, row) => {
    console.log(row.status);
    updateStatus(event)
    setShowRolesModal(true);
    setInquiriesData(row);
  };
  
  const convertDate = (dateString) => {
    const utcTime = moment.utc(dateString);
    const chicagoTime = utcTime.tz("America/Chicago", false);
    return chicagoTime.format("M-D-YYYY, h:mm A");
  };
  //inquiries
  const getAllInquiries = async () => {
    setLoader(true);
    let res = await getInquiryList();

    if (res?.data.success) {
      setInquiries(res?.data?.data);
    }
    setLoader(false);
  };

  useEffect(() => {
    getAllInquiries();
  }, []);
  

  const caseInsensitiveSort = (rowA, rowB, columnId) => {
    const getProperty = (row, columnId) => {
      switch (columnId) {
        case "Name":
          return (row?.name).toLowerCase() || "";
        case "Email":
          return row?.email?.toLowerCase() || "";
        case "Issue":
          return row?.issue || "";
          case "Status":
            return row?.status || "";
        case "Description":
          return row?.description?.toLowerCase() || "";
        case "Specialty":
          return row?.specialty?.toLowerCase() || "";
        case "Created At":
          const endDate = new Date(row?.createdAt);
          return `${
            endDate.getMonth() + 1
          }/${endDate.getDate()}/${endDate.getFullYear()}`.toLowerCase();

        default:
          return "";
      }
    };

    const a = getProperty(rowA, columnId);
    const b = getProperty(rowB, columnId);

    if (a > b) {
      return 1;
    }
    if (b > a) {
      return -1;
    }
    return 0;
  };

  const columns = [
    {
      name: "Name",
      selector: (row) => row?.name,
      sortable: true,
      sortFunction: (a, b) => caseInsensitiveSort(a, b, "Name"),
      button: true
    },
    {
      name: "Email",
      selector: (row) => row?.email,
      sortable: true,
      sortFunction: (a, b) => caseInsensitiveSort(a, b, "Email"),
      width: "220px",
      button: true
    },
    {
      name: "Issue",
      selector: (row) => row?.issue,
      sortable: true,
      sortFunction: (a, b) => caseInsensitiveSort(a, b, "Issue"),
      width: "220px",
      button: true
    },
 
    {
      name: "discription",
      selector: (row) => (<span>{row?.description}</span>),
      sortable: true,
      sortFunction: (a, b) => caseInsensitiveSort(a, b, "Specialty"),
      width: "320px",
      button: true
    },

    
    {
      name: "Status",
      selector: (row) => (
        <>
            {row?.status ? (
              <label className="label label-success m-0">
                Completed
              </label>
            ) : (
              <label className="label label-danger m-0">
                Pending 
              </label>
            )}
        </>
      ),
      sortable: true,
      sortFunction: (a, b) => caseInsensitiveSort(a, b, "Status"),
      button: true
    },

    {
      name: "Created At",
      selector: (row) => convertDate(row?.createdAt),
      width: "200px",
      sortable: true,
      sortFunction: (a, b) => caseInsensitiveSort(a, b, "Created At"),
      button: true
    },

    {
      name: "Actions",
      selector: (row) => (
        
        <>
            <div className="td-actions table-actions-btns">
            <button
              type="button"
              className={`outline-button ${currentUserRole.title === "admin" && row.status === true ? "disabled" : ""}`}
              onClick={(event) => getInquiries(event, row)}
            >
              Response
            </button>
          </div>
        </>
      ),
      sortable: false,
      width: "220px",
      button: true
    },
  ];

  const filterDatatable = (text) => {
    setFilterText(text);
    filterSearchDatatable(selectedOption, text);
  };

  const filterSearchDatatable = (text, searchText) => {
    const filteredItemsResult = inquiries.filter((data) => {
      const name = `${data?.firstName} ${data?.lastName}`;
      if (text) {
        if (
          data.status.toString().toLowerCase().includes(text.toLowerCase()) &&
          (name?.toLowerCase().includes(searchText.toLowerCase()) ||
            data?.email.toLowerCase().includes(searchText.toLowerCase()))
        ) {
          return data;
        }
      } else if (
        name?.toLowerCase().includes(searchText.toLowerCase()) ||
        data?.email.toLowerCase().includes(searchText.toLowerCase())
      ) {
        return data;
      }
      return undefined;
    });
    setFilteredItems([...filteredItemsResult]);
    setSelectedOption(text);
  };

  const resetFilter = () => {
    setFilterText("");
    setFilteredItems([...inquiries]);
    setSelectedOption("");
  };

  const toggleFilterAccordion = () => {
    setIsFilterOpen(!isFilterOpen);
  };

  useEffect(() => {
    if (inquiries) {
      setFilteredItems([...inquiries]);
    }
  }, [inquiries]);

  return (
    <>
      {loader ? (
        <FullPageLoader />
      ) : (
        <div className="pt-2 pt-md-3 job-form-admin-table">
          <Container fluid>
            <Row>
              {/* Start of filter container */}
              <Col md="12">
                <Card className="filter-card card">
                  <Card.Header 
                    style={{ cursor: "pointer" }}
                    onClick={toggleFilterAccordion}
                  >
                    <div className="d-flex align-items-center justify-content-between table-head">
                      <Card.Title className="text-white" as="h4">
                        Filter
                      </Card.Title>
                      <div 
                        style={{ 
                          transform: isFilterOpen ? "rotate(0deg)" : "rotate(180deg)",
                          transition: "transform 0.3s ease"
                        }}
                      >
                        <IoIosArrowUp />
                      </div>
                    </div>
                     
                  </Card.Header>
                  {isFilterOpen && (
                  <Card.Body>
                    <Row>
                      <Col xl={4} sm={6} className="search-wrap">
                        <Form.Group>
                          <Form.Label className="d-block mb-2 text-white">
                            Search with Name...
                          </Form.Label>
                          <Form.Control
                            type="email"
                            name="search"
                            placeholder="Search"
                            value={filterText}
                            onChange={(e) => filterDatatable(e.target.value)}
                          ></Form.Control>
                        </Form.Group>
                      </Col>
                     
                      <Col xl={4} md={6}>
                        <Form.Group>
                          <label className="d-none d-sm-block mb-2 form-label">
                            &nbsp;
                          </label>
                          <div className="d-flex  filter-btns-holder">
                            <button
                              type="button"
                              className="outline-button filter-reset-btn"
                              onClick={() => resetFilter()}
                            >
                              <img src={resetBtn} className="img-fluid mr-3" alt="logo"/>
                              Reset
                            </button>
                          </div>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                  )}
                </Card>
                {/* End of filled container */}

                {/* Start of table for medical type */}
                <div className="datatable-title card d-flex flex-row justify-content-between align-items-center mb-0">
                  <h4 className="card-title">Inquiry Applications</h4>
                </div>
                 <div className="custom-datatable-pagination">
                <DataTable
                  columns={columns}
                  data={filteredItems}
                  theme="solarized"
                  pagination
                  className="react-datatable"
                />
                </div>
              </Col>
            </Row>
          </Container>
          <InquiryModal
              showRolesModal={showRolesModal}
              inquiryData={inquiryData}
              onHide={handleCloseModal} 
              currentElement={currentElement}
              className="inquiry-modal"
            />
        </div>
      )}
    </>
  );
};

export default Inquiry;
